import { LENS_DESKTOP, POLY_LENS_DESKTOP } from "Constants";

export const useGetDesktopInfo = (nestedConnections: any) => {
  if (!nestedConnections) return;

  const flatten = (nestedConns: any) => {
    return nestedConns.reduce((acc: any[], curr: any) => {
      if (curr.connections?.length > 0) {
        acc = acc.concat(flatten(curr.connections));
      }
      return acc.concat(curr);
    }, []);
  };
  // flatten nested list of devices
  let connections = flatten(nestedConnections);

  // remove duplicates from the list of devices
  connections = connections?.filter(
    (conn: any) => conn.name === POLY_LENS_DESKTOP || conn.name === LENS_DESKTOP
  );

  const [mostRecentlyUsed] = connections
    .sort((a: any, b: any) => (a.lastDetected > b.lastDetected ? 1 : -1))
    .slice(-1);

  return mostRecentlyUsed;
};
